module.exports = __webpack_public_path__ + "static/img/product_images_09_h5_zh.3cf4b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_09_h5_zh.png
// module id = y8vo
// module chunks = 34